import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SimpleLoader from "../../components/LogoLoader";
import MiniLoader from "../../components/MiniLoader";
import CoverImage from "./CoverImage";
// import MiniLoader from "../../components/MiniLoader";
// import CardLoader from "../../components/CardLoader";
export default function Creators() {
  const [creators, setCreators] = useState([]);
  const [loading , setLoading] = useState(true);
  const [search, setSearch] = useState("");
const [results, setResults] = useState([]);
const [searchLoading, setSearchLoading] = useState(false);
const [hasSearched, setHasSearched] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCreators();
  }, []);

 const handleSearch = (value) => {
  setSearch(value);

  if (!value) {
    setResults([]);
  }
};

const fetchCreators = async () => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/curator/all`
    );
    const data = await res.json();

    setCreators(Array.isArray(data) ? data : []);
  } catch (err) {
    console.error(err);
    setCreators([]);
  } finally {
    setLoading(false); // ✅ IMPORTANT
  }
};

useEffect(() => {
  if (!search.trim()) {
    setSearchLoading(false);
    setHasSearched(false); // 🔥 reset
    return;
  }

  const loaderTimer = setTimeout(() => {
    setSearchLoading(true);
  }, 600);

  const delay = setTimeout(async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/curator/search?q=${search}`
      );
      const data = await res.json();
      setResults(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
      setResults([]);
    } finally {
      setSearchLoading(false);
      setHasSearched(true); // ✅ search finished
    }
  }, 800);

  return () => {
    clearTimeout(loaderTimer);
    clearTimeout(delay);
  };
}, [search]);
  // 

const dataToShow = search.trim() ? results : creators;
if (loading) {
  return <SimpleLoader />;
}
  return (
    <div className="min-h-screen pb-20 bg-[#f9fafb] font-sans">
  {searchLoading && (
  <div className="fixed inset-0 z-50 flex items-center justify-center">

    {/* BACKDROP (optional blur) */}
    <div className="absolute inset-0 bg-black/10 backdrop-blur-sm"></div>

    {/* LOADER CARD */}
    <div className="relative bg-white rounded-2xl shadow-2xl 
                    px-16 py-8 flex flex-col items-center gap-4 animate-[fadeIn_0.25s_ease]">

      <MiniLoader size={36} />

      <span className="text-base font-semibold text-gray-700">
        Searching...
      </span>
    </div>

  </div>
)}
      {/* 🔥 HERO SECTION */}
      <div className="relative pt-28 pb-20 px-4 mb-16 overflow-hidden">
        {/* Background Image */}
        <img
          src="https://images.unsplash.com/photo-1578894381163-e72c17f2d45f?q=80&w=2106&auto=format&fit=crop"
          alt="Travel Background"
          className="absolute inset-0 w-full h-full object-cover scale-105 blur-[2px]"
        />

        {/* Overlays */}
        <div className="absolute inset-0 bg-black/40"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#5b6f00]/20 via-black/30 to-black/80"></div>

        {/* Content */}
        <div className="max-w-5xl mx-auto relative z-10 text-center">
          {/* Back Button */}
          <div className="absolute top-0 left-0">
            <button
              onClick={() => navigate(-1)}
              className="px-4 py-2 bg-white/10 backdrop-blur-md rounded-full text-white/90 hover:bg-white/20 transition-all flex items-center gap-2 border border-white/20 text-sm font-medium"
            >
              ← Back
            </button>
          </div>

          <div className="inline-block mt-8 md:mt-12">
            <h1 className="text-5xl md:text-7xl font-extrabold text-white tracking-tight mb-6 drop-shadow-lg">
              Discover Creators
            </h1>
            <p className="text-lg md:text-xl text-gray-200 leading-relaxed max-w-2xl mx-auto font-medium drop-shadow-md">
              Explore curated travel experiences crafted by passionate creators.
              Find real itineraries, insider tips, and unique journeys.
            </p>
          </div>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-4 mb-10">
  <input
    type="text"
    placeholder="Search creators or trips..."
    value={search}
    onChange={(e) => handleSearch(e.target.value)}
    className="w-full px-5 py-3 rounded-full border border-gray-200 
               focus:outline-none focus:ring-2 focus:ring-[#5b6f00]/30"
  />
</div>
      {/* 🚀 BECOME CREATOR CTA */}


      <div className="px-4">
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {
      !searchLoading && hasSearched && dataToShow.length === 0 ? (
            <div className="col-span-full flex flex-col items-center justify-center py-24 text-center">
              <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center text-4xl mb-6 shadow-sm">
                🌍
              </div>
              <h3 className="text-2xl font-bold text-[#1f2d1f] mb-2">No creators found</h3>
              <p className="text-gray-500">Be the first to create and share your curated trips.</p>
            </div>
          ) : (
            dataToShow.map((item, index) => {
  // 🔥 TRIP CARD
  if (item.type === "trip") {
    return (
      <div
        key={item._id}
        onClick={() => navigate(`/curated/${item._id}`)}
        className="bg-white rounded-[20px] p-3 sm:p-4 
                   shadow-[0_4px_20px_rgb(0,0,0,0.03)] 
                   hover:shadow-[0_12px_30px_rgb(91,111,0,0.08)] 
                   hover:-translate-y-1.5 active:scale-[0.97]
                   transition-all duration-300 cursor-pointer 
                   flex flex-col group border border-gray-100"
      >
        {/* IMAGE */}
      <div className="relative w-full aspect-[1/1] sm:aspect-square rounded-[16px] overflow-hidden bg-gray-100 mb-4">

  {/* MAIN IMAGE */}
 <CoverImage
  city={item.city}
  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
/>

  {/* 🔥 CREATOR AVATAR (TOP RIGHT) */}
  <div className="absolute top-3 right-3 w-10 h-10 rounded-full overflow-hidden bg-white shadow-md flex items-center justify-center">
    {item.creator?.avatar ? (
      <img
        src={item.creator.avatar}
        alt={item.creator?.name}
        className="w-full h-full object-cover"
      />
    ) : (
      <span className="text-sm font-bold text-[#5b6f00]">
        {item.creator?.name?.[0]?.toUpperCase() || "C"}
      </span>
    )}
  </div>

  {/* TAG */}
  <div className="absolute top-3 left-3 bg-white/90 text-[10px] font-bold px-2.5 py-1 rounded-full">
    Trip
  </div>
</div>

        {/* CONTENT */}
        <div className="flex flex-col flex-1 px-1">
          <h3 className="font-serif text-[15px] sm:text-lg font-bold text-[#1f2d1f]">
            {item.title}
          </h3>

          <p className="text-[12px] text-gray-500">
            {item.city}
          </p>
        </div>
      </div>
    );
  }

  // 🔥 CREATOR CARD (your SAME UI)
  return (
    <div
      key={item._id}
      onClick={() => navigate(`/creator/${item.userId}`)}
      className="bg-white rounded-[20px] p-3 sm:p-4 
                 shadow-[0_4px_20px_rgb(0,0,0,0.03)] 
                 hover:shadow-[0_12px_30px_rgb(91,111,0,0.08)] 
                 hover:-translate-y-1.5 active:scale-[0.97]
                 transition-all duration-300 cursor-pointer 
                 flex flex-col group border border-gray-100"
    >
      {/* IMAGE */}
      <div className="relative w-full aspect-[1/1] sm:aspect-square rounded-[16px] overflow-hidden bg-gray-100 mb-4">
        {item.avatar ? (
          <img
            src={item.avatar}
            alt={item.fullName}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-4xl font-serif text-[#1f2d1f]/20 bg-[#f7f6f1]">
            {item.fullName?.[0]}
          </div>
        )}

        {/* TOP CREATOR BADGE */}
        {index < 3 && (
          <div className="absolute top-3 left-3 bg-white/90 backdrop-blur-sm shadow-sm text-[#1f2d1f] text-[10px] font-bold px-2.5 py-1 rounded-full flex items-center gap-1">
            <span className="text-[#5b6f00]">★</span> Top Creator
          </div>
        )}
      </div>

      {/* CONTENT */}
      <div className="flex flex-col flex-1 px-1">
        <div className="flex items-center justify-between mb-1">
          <h3 className="font-serif text-[15px] sm:text-lg font-bold text-[#1f2d1f] line-clamp-1 group-hover:text-[#5b6f00] transition-colors">
            {item.fullName}
          </h3>

          <svg className="w-4 h-4 text-[#5b6f00]" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M16.403 12.652a3 3 0 000-5.304 3 3 0 00-3.75-3.751 3 3 0 00-5.305 0 3 3 0 00-3.751 3.75 3 3 0 000 5.305 3 3 0 003.75 3.751 3 3 0 005.305 0 3 3 0 003.751-3.75z" />
          </svg>
        </div>

        <p className="text-[12px] sm:text-[13px] text-gray-500 mb-3">
          {item.location || "Travel Creator"}
        </p>

        <div className="mt-auto pt-3 border-t border-gray-100 flex justify-end">
          <span className="text-[12px] font-bold text-[#1f2d1f] group-hover:text-[#5b6f00] flex items-center gap-1">
            Explore <span className="text-lg">›</span>
          </span>
        </div>
      </div>
    </div>
  );
})
          )}
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-6 mt-24 mb-24">
             
                <div className="bg-white rounded-[28px] p-8 md:p-10 
                border border-gray-100 
                shadow-[0_10px_40px_rgb(0,0,0,0.05)] 
                flex flex-col md:flex-row items-center justify-between gap-8">
                {/* TEXT */}
                <div className="max-w-xl">
                  <h2 className="text-2xl md:text-3xl font-bold text-[#1f2d1f] mb-2">
                    Become a Creator 🚀
                  </h2>

                  <p className="text-gray-600 text-sm md:text-base">
                    Turn your travel into something bigger — not just content, but digital
                    products people can use (and soon pay for).
                  </p>

                  <p className="text-xs text-gray-400 mt-2">
                    🚧 Beta: Monetization coming soon. Early creators get first access.
                  </p>
                </div>

                {/* BUTTON */}
                <button
                  onClick={() => navigate("/become-creator")}
                  className="px-6 py-3 bg-[#5b6f00] text-white rounded-full font-semibold 
                            hover:opacity-90 transition-all shadow-md"
                >
                  Become a Creator →
                </button>
              </div>
            </div>
          </div>
  );
}